__webpack_require__.p = "https://assets.coolblue.nl/_app/add-to-cart-page-microfrontend/_next/";